var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeDropperFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.75 333.25C38.75 345.25 32 361.531 32 378.5V424L0 480L32 512L88 480H133.5C150.469 480 166.75 473.25 178.75 461.25L304 336L176 208L50.75 333.25ZM483.875 28.125C446.406 -9.375 385.594 -9.375 348.125 28.125L271.031 105.219L257.938 92.125C248.5 82.656 233.281 82.812 224 92.125L183.031 133.094C173.656 142.438 173.656 157.656 183.031 167.031L344.969 328.969C354.406 338.406 369.625 338.281 378.906 328.969L419.875 288C429.25 278.625 429.25 263.438 419.875 254.062L406.781 240.969L483.875 163.875C521.375 126.375 521.375 65.625 483.875 28.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDropperFull);
export default __webpack_public_path__ + "static/media/eye-dropper-full.a8f48c75a7dc52f84dbe767941f49c68.svg";
export { ForwardRef as ReactComponent };